const VehicleDepartmentInitialState = "";
export const VehicleDepartmentReducer = (
  state = VehicleDepartmentInitialState,
  action
) => {
  switch (action.type) {
    case "VEHICLEDEPARTMENT":
      return action.payload;
    default:
      return state;
  }
};
